var lydz = {
  fukuanshenqing: [
    {
      title: "付款原因",
      key: "reason",
      type: "Input",
      required: true
    },
    {
      title: "金额",
      key: "money",
      type: "InputNumber",
      required: true    
    },
    {
      title: "订单号",
      key: "ono",
      slotForm: "ono"   
    },
    {
      title: "支付时间",
      key: "payTime",
      key2: "payTime2",
      type: "lyyymmdd",
      required: true
    },
    {
      title: "收款单位",
      key: "customers",
      type: "Input",
      required: true
    },
    {
      title: "支付账号",
      key: "account",
      type: "Input"
    },
    {
      title: "付款方式",
      key: "types",
      type: "Select",
      selectItems: ["网银", "微信", "支付宝", "现金", "其他"]
    },
    {
      title: "开户银行",
      key: "bank",
      type: "Input"
    },
    {
      title: "附件",
      key: "filesPathArr",
      type: "lyPhoto",
      slot: "pic"
    },
    {
      title: "备注信息",
      key: "remark",
      type: "Input"
    }
  ],
  baoxiaoshenqing: [
    {
      title: "客户名称",
      key: "customer",
      type: "Input",
      required: true
    },
    {
      title: "订单号",
      key: "ono",
      slotForm: "ono"
    },
    {
      title: "用途事项",
      key: "itemList",
      slot: "itemList",
      slotForm: "itemList",
      noTable: false,
      required: true,
      type: "table",
      width: 200,
      span: 24
    },
    {
      title: "原借金额",
      key: "moneyBorrow",
      type: "InputNumber",
      required: true
    },

    {
      title: "附件",
      key: "filesPathArr",
      type: "lyPhoto",
      slot: "pic",
      api: "/cloud-tms-server-rpt/integratedCost/update"
    },
    {
      title: "备注信息",
      key: "remark",
      type: "Input"
    }
  ],
  qianzi: [
    {
      title: "流水号",
      key: "title",
      key1: "title",
      type: "Input",
      span: 24,
      readonly: true,
      required: true
    },
    {
      title: "职务",
      key: "role",
      type: "Input",
      span: 24,
      required: true,
      readonly: true
    },
    {
      title: "签字",
      key: "name",
      type: "Input",
      span: 24,
      required: true,
      readonly: true
    },
    {
      title: "处理意见",
      key: "comment",
      type: "Input",
      span: 24,
      required: true
    },
    {
      title: "签字日期",
      key: "signTime",
      type: "lyyymmdd",
      span: 24,
      required: true
    }
  ]
};

export default lydz;



// WEBPACK FOOTER //
// ./src/components/wuliu/caiwufeiyong/fields.js